






















import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcomeProduct } from '@/shared/appointments/appointment-outcome-product';
import { InstructionType } from '@/shared/instruction-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class AppointmentOutcomeProductDetails extends Vue {
    @typesModule.Getter('appointmentProductTypes') private appointmentProductTypes!: Array<AppointmentProductType>;
    @typesModule.Getter('appointmentPaymentStatusTypes') private appointmentPaymentStatusTypes!: Array<AppointmentPaymentStatusType>;

    @Prop({ required: true }) private products!: Array<AppointmentOutcomeProduct>;
    @Prop({ required: true }) private appointment!: Appointment;
    @Prop({ required: false, default: false }) private isEdit!: boolean;

    private appointmentProductTypeDescription(product: AppointmentOutcomeProduct): string {
        const appointmentProductType = this.appointmentProductTypes.find((type) => type.id === product.productTypeId);
        return appointmentProductType == null ? '' : appointmentProductType.value;
    }

    private appointmentInstructionTypeDescription(product: AppointmentOutcomeProduct): string {
        switch (product.instructionType) {
            case InstructionType.NotInstructed:
                return 'Not Instructed';

            case InstructionType.CoolingOff:
                return '14 Day Cooling Off Period';

            case InstructionType.ConsideringOptions:
                return 'Considering Options';

            case InstructionType.Instructed:
                return 'Instructed';

            default:
                return '';
        }
    }

    private appointmentPaymentStatusTypeDescription(product: AppointmentOutcomeProduct): string {
        if (product.paymentDetails == null || !product.paymentDetails.length) {
            return '';
        }

        if (product.paymentDetails.length > 1) {
            for (const payment of product.paymentDetails) {
                const paymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.id === payment.paymentStatusId);

                if (paymentStatusType != null && paymentStatusType.isComplete) {
                    continue;
                }

                return 'Part Payment';
            }

            return 'Cleared';
        }

        if (product.paymentDetails[0].paymentStatusId == null) {
            return '';
        }

        const productPaymentStatusType = this.appointmentPaymentStatusTypes.find((type) => type.id === product.paymentDetails[0].paymentStatusId);
        return productPaymentStatusType == null ? '' : productPaymentStatusType.value;
    }
}
